import React from 'react';
import { ControlSelect } from './InsightPage';

/** Window lengths in days. Each window runs from that many days ago to today. */
export const WINDOW_OPTIONS = [
  { value: 30, label: 'Last 30 days' },
  { value: 90, label: 'Last 90 days' },
  { value: 180, label: 'Last 180 days' },
  { value: 365, label: 'Last 365 days' },
];

const DateWindowSelect = ({ value, onChange, label = 'Time window', id = 'insightWindow' }) => (
  <ControlSelect id={id} label={label} value={value} onChange={(e) => onChange(Number(e.target.value))}>
    {WINDOW_OPTIONS.map((o) => (
      <option key={o.value} value={o.value}>{o.label}</option>
    ))}
  </ControlSelect>
);

export default DateWindowSelect;
